import { render, staticRenderFns } from "./RemoveConfigConfirm.vue?vue&type=template&id=fb58b0c2&scoped=true&"
import script from "./RemoveConfigConfirm.vue?vue&type=script&lang=ts&"
export * from "./RemoveConfigConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveConfigConfirm.vue?vue&type=style&index=0&id=fb58b0c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb58b0c2",
  null
  
)

export default component.exports